import { CodeBook } from "@king-ict/eupisi-ui/models/Common/CodeBook";

import { CommitteePosition, CommitteeTypeEnum } from "../Committee";
import { Role } from "../Shared/Role";
import { User } from "./User";

export interface UserPermission extends CodeBook {
    user: User;
    canImpersonate: boolean;
    rolePermissions?: Role[];
    locations?: number[];
    committeeMemberships: CommitteeMember[];
    claimType: ClaimType;
    role: number;

    impersonator?: UserPermission;
}

export enum ClaimType
{
    /**
     * Institution level claims.
     */
    Institution = 1,
    /**
     * County level claims.
     */
    County,
    /**
     * Not used.
     */
    Role,
    /**
     * Global claims include CAS, Helpdesk, MinistryAdministrator and MinistryCommittee.
     */
    Global,
    /**
     * This ClaimType is currently only used for RegionalCommittee (Ispostava) members.
     */
    Committee,
}

export interface CommitteeMember {
    committeeId: number;
    committeeType: CommitteeTypeEnum;
    institutionId?: number;
    countyId?: number;
    committeePosition: CommitteePosition;
    isPresident: boolean;
    committeeEmployeeId: number;
    committeeRoleId: number; // These roles cannot be an enum.
    isCroatianLanguageTeacher: boolean;
    /**
     * Used for RegionalCommittee members. While a RegionalCommittee 
     * belongs to a County, it only has permissions for a few Institutions. 
     * This array holds these Institution Ids.
     * 
     * One person may be a member of several RegionalCommittees and may be 
     * the president in one but not another. They, therefore, act as the 
     * president for some Institutions but not others.
     */
    regionalCommitteeInstitutionIds?: number[];
}